<template>
  <div class="form-row hide-label">
    <div class="col-12 col-md-6">
      <label class="replacement-label">{{label}}</label>
      <input-date-timepicker
        ref="startTimePicker"
        id="start_time"
        v-model="start_time"
        v-validate="'required'"
        name="start_time"
        data-vv-name="start_time"
        data-vv-as="start time"
        :timeLabel="label2"
        type="number"
        required
        :error="errors.first('start_time')"
        :disabled-dates="disabledDates"
      />
    </div>
    <div class="col-12 col-md-6">
      <label class="replacement-label">{{label3}}</label>
      <input-date-timepicker
        ref="endTimePicker"
        id="end_time"
        v-model="end_time"
        v-validate="'required'"
        :hideDayPicker="true"
        name="end_time"
        data-vv-name="end_time"
        data-vv-as="end time"
        label="End Time"
        type="number"
        required
        :error="errors.first('end_time')"
        :disabled-dates="disabledDates"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import InputDateTimepicker from '@/components/inputs/InputDateTimepicker.vue';

export default {
  name: 'InputSingleDateTimeRangePicker',
  components: {
    InputDateTimepicker,
  },
  props: {
    initialStartTime: {
      type: String,
    },
    initialEndTime: {
      type: String,
    },
    disableDates: {
      type: [Boolean, Object],
      default() {
        return true;
      },
    },
    onSetDate: {
      type: Function,
      default() {
        return ()=>{};
      },
    },
    autoSetEndTimePlusMinutes: {
      type: Number,
      default() {
        return 0;
      },
    },
    label: {
      type: String,
      default() {
        return '';
      },
    },
    label2: {
      type: String,
      default() {
        return '';
      },
    },
    label3: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      start_time: '',
      end_time: '',
    };
  },
  computed: {
    disabledDates() {
      if (typeof this.disableDates === 'object' && this.disableDates !== null) {
        return this.disableDates;
      }
      return this.disableDates ? { to: new Date() } : {};
    }
  },
  mounted() {
    this.start_time = this.initialStartTime || '';
    this.end_time = this.initialEndTime || '';

    if (this.start_time && this.$refs.startTimePicker) {
      this.$refs.startTimePicker.reset(this.start_time);
    }

    if (this.end_time && this.$refs.endTimePicker) {
      this.$refs.endTimePicker.reset(this.end_time);
    }
  },
  methods: {
    validate() {
      return this.$validator.validateAll();
    },
    reset(start, end) {
      this.start_time = start || '';
      this.end_time = end || '';
    },

    getDateRange() {
      return {
        start_time: this.start_time,
        end_time: this.end_time,
      };
    },
  },
  watch: {
    start_time(v) {
      if (this.onSetDate) {
        this.onSetDate(this.start_time);
      }

      if (v)
        this.end_time = v;

      if (v && this.autoSetEndTimePlusMinutes) {
        const dt = moment.utc(v);
        this.end_time = dt.add(this.autoSetEndTimePlusMinutes, 'minutes').toISOString();

        if (this.$refs.startTimePicker.start_time_time) {
          this.$refs.endTimePicker.reset(this.end_time);
        }
      }

    },
  }
};

</script>